import { DollarOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";

import { connect } from "react-redux";
import * as actions from "../../../../store/actions/action";
import { dataFetchError } from "../../../../Util/Messages";
import api from "../../../../api/api";
import { Button, Input, Popconfirm, Tag } from "antd";

import CheckPermission from "../../../../Util/CheckPermission";
import { PageHeader } from "@ant-design/pro-components";

const Price = ({ LoadingSetter, ClearLoading, loading, permissions }) => {
  const [data, setData] = useState([]);

  const loadData = () => {
    LoadingSetter();
    api
      .get("/statuses", { params: { take: 1000, skip: 0 } })
      .then((res) => {
        setData(res.data);
        ClearLoading();
      })

      .catch((err) => {
        console.log(err);
        ClearLoading();
        dataFetchError();
      });
  };

  useEffect(() => {
    loadData();
    // loadFlagsData();
  }, []);

  return (
    <>
      <PageHeader title="قیمت محصول" avatar={{ icon: <DollarOutlined /> }} />
      <h1>قیمت فعلی:</h1>
      <h2>500000 تومان</h2>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Input type="number" size="large" placeholder="قیمت جدید" />
        <Popconfirm title="آیا از تغییر قیمت محصول مطمئن هستید؟">
          <Button size="large" type="primary" style={{ marginRight: "0.5rem" }}>
            تغییر قیمت
          </Button>
        </Popconfirm>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Price);
